export const themeColors: {
  info: ThemeColor;
  success: ThemeColor;
  error: ThemeColor;
  warning: ThemeColor;
  alert: ThemeColor;
  gray: ThemeColor;
  typography: ThemeColor;
} = {
  info: {
    lightest: '#F1F7FF',
    light: '#9cc5ff',
    main: '#3484FA',
    dark: '#2352a4',
    darkest: '#1b3b7a',
  },
  success: {
    lightest: '#DFF6F0',
    light: '#85DBC5',
    main: '#21AA91',
    dark: '#127874',
    darkest: '#0C5A5D',
  },
  error: {
    lightest: '#FBEAE5',
    light: '#FEAD9A',
    main: '#D33618',
    dark: '#BF0711',
    darkest: '#330101',
  },
  warning: {
    lightest: '#FCEBDB',
    light: '#FFC58B',
    main: '#F49342',
    dark: '#C05717',
    darkest: '#4A1504',
  },
  alert: {
    lightest: '#FCF1CD',
    light: '#FFEA8A',
    main: '#EEC200',
    dark: '#8A6116',
    darkest: '#573B00',
  },
  gray: {
    lightest: '#F1F3F5',
    light: '#DEE2E6',
    main: '#ADB5BD',
    dark: '#343A40',
    darkest: '#1E252B',
  },
  typography: {
    lightest: '#F1F3F5',
    light: '#DEE2E6',
    main: '#ADB5BD',
    dark: '#343A40',
    darkest: '#1E252B',
  },
};

interface ThemeColor {
  lightest: string;
  light: string;
  main: string;
  dark: string;
  darkest: string;
}
